export const reduxKey = '@@favouritedByModal';

//# sourceMappingURL=constants.js.map